import { ImgHTMLAttributes } from 'react';
import { getImagesStaticUrl } from '../../../../helpers';

export const HeroImage = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img alt={props.alt || ''} {...props} src={getImagesStaticUrl('lock-in-rate-hero.jpg')} />
);
